import React from 'react';

export interface LinkProps {
    href?: string;
    ariaLabel?: string;
    target?: string;
    rel?: string;
    disabled?: boolean;
    className?: string;
    children?: React.ReactNode;
    tabIndex?: number;
}

export const Link: React.FC<LinkProps> = ({ href, target = '_self', rel, className, children, disabled, ariaLabel, tabIndex }) => {
  return (
    <a
      data-testid='link'
      href={href}
      target={target}
      rel={rel}
      tabIndex={tabIndex}
      className={`${disabled ? '' : 'cursor-pointer'} ${className}`}
      aria-label={ariaLabel}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
        }
      }}
    >
      {children}
    </a>
  );
};
